import * as React from 'react'
import * as Types from '../declarations'
import { versionFromHostname } from '../lib/withVersion'

// Define the interface for the context
interface VersionContext {
	version: Types.VERSION
	setVersion?: (version: Types.VERSION) => void
}

// Create the context
export const VersionContext = React.createContext<VersionContext>({
	version: process.env.NEXT_PUBLIC_SITE_VERSION as Types.VERSION,
})

const VersionProvider = ({
	children,
	initialVersion,
}: {
	children: React.ReactNode
	// resolved server-side from the request host (app getInitialProps) —
	// NEXT_PUBLIC_SITE_VERSION is not reliably inlined in every build, so
	// without this SSR renders the TREKKING fallback (issue #123)
	initialVersion?: Types.VERSION
}) => {
	// Use the existing function for version detection based on hostname
	const getVersionFromHostname = (): Types.VERSION =>
		typeof window === 'undefined'
			? ((process?.env?.NEXT_PUBLIC_SITE_VERSION as Types.VERSION) ??
					Types.VERSION.TREKKING)
			: versionFromHostname(window.location.hostname)

	// Set the initial state based on the hostname
	const [version, setVersion] = React.useState<Types.VERSION>(
		initialVersion ??
			(process?.env?.NEXT_PUBLIC_SITE_VERSION as Types.VERSION) ??
			getVersionFromHostname(),
	)

	return (
		<VersionContext.Provider value={{ version, setVersion }}>
			{children}
		</VersionContext.Provider>
	)
}

// export { VersionContext, VersionProvider }

export default VersionProvider
